import { AU_STATES } from "./phone.js";

/**
 * Australian time zones. A business runs on its own state's local time, and the platform admin sets the state (Admin > Businesses); the
 * database derives businesses.timezone from it (migration 0054, fn_au_timezone_for_state). This is the same table, for the screens that
 * want to show the result before it is saved.
 */
export const STATE_TIME_ZONE: Record<(typeof AU_STATES)[number], string> = {
  "New South Wales": "Australia/Sydney",
  "Australian Capital Territory": "Australia/Sydney", // the ACT keeps NSW time
  Victoria: "Australia/Melbourne",
  Tasmania: "Australia/Hobart",
  Queensland: "Australia/Brisbane", // no daylight saving
  "South Australia": "Australia/Adelaide",
  "Western Australia": "Australia/Perth",
  "Northern Territory": "Australia/Darwin",
};

const ABBREVIATION: Record<string, (typeof AU_STATES)[number]> = {
  nsw: "New South Wales",
  act: "Australian Capital Territory",
  vic: "Victoria",
  tas: "Tasmania",
  qld: "Queensland",
  sa: "South Australia",
  wa: "Western Australia",
  nt: "Northern Territory",
};

/** The time zone for a state (full name or abbreviation, any case), or null when it is not an Australian state. */
export function timeZoneForState(state: string | null | undefined): string | null {
  const key = (state ?? "").trim().toLowerCase();
  if (!key) return null;
  const full = ABBREVIATION[key] ?? AU_STATES.find((s) => s.toLowerCase() === key);
  return full ? STATE_TIME_ZONE[full] : null;
}

/** "Melbourne time" for "Australia/Melbourne" (the city the zone is named after). */
export function timeZoneLabel(timeZone: string): string {
  const city = timeZone.split("/").pop() ?? timeZone;
  return `${city.replace(/_/g, " ")} time`;
}
